import React from 'react';
import { Button, EmptyState, PageContainer, PageHeader } from '../ui/components';
import { Icon } from '../ui/icons';
import { useT } from '../i18n';

/**
 * Generic placeholder for procurement modules that aren't built yet. Each route
 * passes its title, description and icon so the shell feels complete while the
 * underlying features land in later phases.
 */
export default function ModulePage({ title, description, icon: IconCmp, primaryAction }) {
  const t = useT();
  return (
    <PageContainer size="full">
      <PageHeader
        title={t(title)}
        description={t(description)}
        icon={IconCmp ? <IconCmp size={22} /> : undefined}
        actions={
          primaryAction ? (
            <Button variant="primary" leadingIcon={<Icon.Plus size={16} />} disabled>
              {t(primaryAction)}
            </Button>
          ) : undefined
        }
      />
      <EmptyState
        icon={IconCmp ? <IconCmp size={30} /> : <Icon.LayoutGrid size={30} />}
        title={t('Coming soon')}
        description={t('{title} is part of the procurement roadmap and will be available in an upcoming phase.', { title: t(title) })}
      />
    </PageContainer>
  );
}
